export const debounce = <T extends (...args: any[]) => Promise<any>>(callback: T, delay: number) => {
  let timeout: ReturnType<typeof setTimeout> | undefined
  let call = 0
  return ((...args) => {
    let resolve: (value: any) => void
    let reject: (reason?: any) => void
    const promise = new Promise((res, rej) => {
      resolve = res
      reject = rej
    })
    clearTimeout(timeout)
    call++
    const currentCall = call
    timeout = setTimeout(async () => {
      try {
        const result = callback(...args)
        if (call === currentCall) {
          resolve(result)
        }
      } catch (error) {
        if (call === currentCall) {
          reject(error)
        }
      }
    }, delay)
    return promise
  }) as T
}
